"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Enlarge32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M16.24 21.232A9.5 9.5 0 1122 12.5a9.454 9.454 0 01-1.537 5.171 9.535 9.535 0 01-4.223 3.561zm11.872 4.089l-6.925-6.925A10.443 10.443 0 0023 12.5C23 6.701 18.299 2 12.5 2S2 6.701 2 12.5C2 18.298 6.701 23 12.5 23c1.608 0 3.126-.372 4.489-1.019l7.231 7.231a1.103 1.103 0 001.562.006l2.336-2.335a1.102 1.102 0 00-.006-1.562z" }),
    react_1.default.createElement("path", { d: "M16.002 11.041h-2.127V8.998c0-.552-.322-.957-.874-.957h-1.002c-.556 0-1.124.406-1.124.957v2.043H8.998c-.552 0-1.123.406-1.123.958v1.002c0 .556.572 1.04 1.123 1.04h1.877v1.962c0 .551.572 1.038 1.124 1.038h1.002c.556 0 .874-.487.874-1.038v-1.962h2.127c.552 0 .873-.488.873-1.04v-1.002c0-.556-.322-.958-.873-.958z" }))); };
var StyledEnlarge32 = styled_components_1.default(Enlarge32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledEnlarge32;
var templateObject_1;
//# sourceMappingURL=Enlarge32.js.map